export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/hotelBumper-95c47b278b11fd45016cf1f6a030ac19.png";